import { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './ImageView.module.scss';

const checkSrc = (originSrc) => {
  if (originSrc.includes('http')) {
    const url = new URL(originSrc);
    if (url.host === window.location.host) return url.pathname + url.search;
  }
  return originSrc;
};

function ImageView({ contentRef }) {
  const [img, setImg] = useState({});

  const toggleImg = useCallback(({ src, alt }) => setImg((prevImg) => {
    if (prevImg.src === src) return {};
    return { src, alt };
  }));

  const onImgClick = useCallback((e) => {
    if (!e.target) return;
    if (e?.target?.tagName === 'IMG') {
      e.preventDefault();
      e.stopPropagation();
    }
    const { src, alt = '' } = e.target;
    if (src) toggleImg({ src: checkSrc(src), alt });
  });

  useEffect(() => {
    if (contentRef && contentRef.current) {
      contentRef.current.addEventListener('click', onImgClick, false);
      return () => contentRef.current?.removeEventListener('click', onImgClick, false);
    }
    return () => {};
  }, []);
  return (
    <div className={classnames(styles.imageView, { [styles.modelShow]: img.src })} aria-hidden="true" onClick={toggleImg}>
      <figure>{img.src && <img src={img.src} alt={img.alt} />}</figure>
    </div>
  );
}

ImageView.propTypes = {
  contentRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
};

export default ImageView;
